import React, { useEffect, useState, createElement } from 'react';
function CheckIcon() {
  return <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#f97316" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="mt-1 flex-shrink-0" aria-hidden="true" data-id="element-0">
      <polyline points="20 6 9 17 4 12" data-id="element-1" />
    </svg>;
}
const BENEFITS = ['Todo explicado por Beatriz Espina desde cero', 'Cómo preparar tu cuerpo y tu mente para esta experiencia', 'Técnica real, paso a paso, hasta experta', 'Sin mitos. Sin vergüenza. Con información profesional.'];
export function App() {
  const [secondsLeft, setSecondsLeft] = useState(10 * 60);
  useEffect(() => {
    if (secondsLeft <= 0) return;
    const id = setInterval(() => {
      setSecondsLeft(s => s > 0 ? s - 1 : 0);
    }, 1000);
    return () => clearInterval(id);
  }, [secondsLeft]);
  // Load and mount the Hotmart Sales Funnel widget
  useEffect(() => {
    const mountWidget = () => {
      try {
        // @ts-ignore - injected by the Hotmart script
        window.checkoutElements?.init('salesFunnel').mount('#hotmart-sales-funnel');
      } catch (e) {
        // ignore mount errors (e.g. running outside Hotmart context)
      }
    };
    // @ts-ignore
    if (window.checkoutElements) {
      mountWidget();
      return;
    }
    const existing = document.querySelector('script[src="https://checkout.hotmart.com/lib/hotmart-checkout-elements.js"]') as HTMLScriptElement | null;
    if (existing) {
      existing.addEventListener('load', mountWidget);
      return () => existing.removeEventListener('load', mountWidget);
    }
    const script = document.createElement('script');
    script.src = 'https://checkout.hotmart.com/lib/hotmart-checkout-elements.js';
    script.async = true;
    script.onload = mountWidget;
    document.body.appendChild(script);
  }, []);
  const expired = secondsLeft <= 0;
  const minutes = String(Math.floor(secondsLeft / 60)).padStart(2, '0');
  const seconds = String(secondsLeft % 60).padStart(2, '0');
  return <main className="w-full min-h-full flex justify-center" style={{
    backgroundColor: '#0a0a0a',
    color: '#ffffff'
  }} data-id="element-2">
      <div className="relative w-full max-w-[480px] overflow-hidden" data-id="element-3">
        {/* Soft coral/orange abstract glow shapes */}
        <div aria-hidden="true" className="pointer-events-none absolute -top-24 -left-24 h-72 w-72 rounded-full" style={{
        background: '#f97316',
        opacity: 0.18,
        filter: 'blur(90px)'
      }} data-id="element-4" />
        <div aria-hidden="true" className="pointer-events-none absolute top-1/3 -right-28 h-80 w-80 rounded-full" style={{
        background: '#fb7185',
        opacity: 0.14,
        filter: 'blur(100px)'
      }} data-id="element-5" />
        <div aria-hidden="true" className="pointer-events-none absolute bottom-0 -left-20 h-72 w-72 rounded-full" style={{
        background: '#f97316',
        opacity: 0.12,
        filter: 'blur(110px)'
      }} data-id="element-6" />

        {/* 1. URGENCY BAR */}
        <div className="relative w-full text-center font-bold text-white" style={{
        backgroundColor: '#f97316',
        fontSize: '13px',
        textTransform: 'uppercase',
        letterSpacing: '0.1em',
        padding: '10px 16px'
      }} data-id="element-7">
          Oferta especial — Solo para ti, solo en este momento
        </div>

        <div className="relative px-6 py-8" data-id="element-8">
          {/* 2. PERSONAL MESSAGE BLOCK */}
          <div className="rounded-lg" style={{
          backgroundColor: '#1a1a1a',
          borderLeft: '3px solid #f97316',
          padding: '20px'
        }} data-id="element-9">
            <p style={{
            color: '#f97316',
            fontSize: '12px',
            textTransform: 'uppercase',
            letterSpacing: '0.08em',
            marginBottom: '10px',
            fontWeight: 600
          }} data-id="element-10">
              Un momento antes de irte
            </p>
            <p style={{
            color: '#d1d5db',
            fontSize: '16px',
            lineHeight: 1.8
          }} data-id="element-11">
              Está bien si lo otro no era para ti en este momento. Pero Beatriz
              quiso dejarte algo diferente. Algo que es completamente tuyo.
            </p>
          </div>

          {/* 3. COUNTDOWN TIMER */}
          <div className="mt-8 text-center" data-id="element-12">
            <p style={{
            color: '#ffffff',
            fontSize: '13px',
            marginBottom: '8px'
          }} data-id="element-13">
              Disponible por:
            </p>
            {expired ? <p style={{
            color: '#9ca3af',
            fontSize: '15px'
          }} data-id="element-14">
                Esta oferta ya no está disponible.
              </p> : <div className="flex items-end justify-center gap-4" data-id="element-15">
                <div className="flex flex-col items-center" data-id="element-16">
                  <span style={{
                color: '#f97316',
                fontSize: '36px',
                fontWeight: 800,
                lineHeight: 1
              }} data-id="element-17">
                    {minutes}
                  </span>
                  <span style={{
                color: '#ffffff',
                fontSize: '11px',
                marginTop: '4px'
              }} data-id="element-18">
                    MIN
                  </span>
                </div>
                <span style={{
              color: '#f97316',
              fontSize: '36px',
              fontWeight: 800,
              lineHeight: 1
            }} aria-hidden="true" data-id="element-19">
                  :
                </span>
                <div className="flex flex-col items-center" data-id="element-20">
                  <span style={{
                color: '#f97316',
                fontSize: '36px',
                fontWeight: 800,
                lineHeight: 1
              }} data-id="element-21">
                    {seconds}
                  </span>
                  <span style={{
                color: '#ffffff',
                fontSize: '11px',
                marginTop: '4px'
              }} data-id="element-22">
                    SEG
                  </span>
                </div>
              </div>}
          </div>

          {/* 4. HEADLINE */}
          <h1 className="mt-8 text-center" style={{
          fontSize: '30px',
          fontWeight: 700,
          color: '#ffffff',
          lineHeight: 1.25
        }} data-id="element-23">
            Antes de irte — Beatriz tiene algo que es solo para ti.
          </h1>

          {/* 5. SUBHEADLINE */}
          <p className="mt-4 text-center" style={{
          fontSize: '18px',
          color: '#9ca3af',
          lineHeight: 1.5
        }} data-id="element-24">
            No es sobre él. No es sobre la pareja. Esta clase es completamente
            tuya.
          </p>

          {/* 6. STAT CALLOUT CARD */}
          <div className="mt-8 text-center rounded-lg" style={{
          backgroundColor: '#1a1a1a',
          border: '1px solid #f97316',
          padding: '24px'
        }} data-id="element-25">
            <p style={{
            fontSize: '64px',
            fontWeight: 700,
            color: '#f97316',
            lineHeight: 1
          }} data-id="element-26">
              55%
            </p>
            <p style={{
            fontSize: '16px',
            color: '#d1d5db',
            lineHeight: 1.7,
            marginTop: '12px'
          }} data-id="element-27">
              de las mujeres nunca ha experimentado un squirt. Hoy puedes
              empezar a ser parte del otro grupo.
            </p>
          </div>

          {/* 7. DESCRIPTION */}
          <p className="mt-8 text-center" style={{
          fontSize: '16px',
          color: '#d1d5db',
          lineHeight: 1.8
        }} data-id="element-28">
            Con la guía profesional de Beatriz Espina, vas a entender
            exactamente qué está pasando en tu cuerpo, qué necesitas y cómo
            llegar ahí — sola o acompañada — sin mitos, sin tabúes y sin
            información falsa de internet.
          </p>

          {/* 8. PRODUCT NAME */}
          <div className="mt-8 text-center" data-id="element-29">
            <p style={{
            fontSize: '48px',
            fontWeight: 700,
            color: '#ffffff',
            lineHeight: 1
          }} data-id="element-30">
              SQUIRT
            </p>
            <p style={{
            fontSize: '16px',
            color: '#9ca3af',
            marginTop: '4px'
          }} data-id="element-31">
              de cero a experto
            </p>
          </div>

          {/* 9. BENEFITS LIST */}
          <ul className="mt-8 space-y-2" data-id="element-32">
            {BENEFITS.map(b => <li key={b} className="flex items-start gap-2" style={{
            fontSize: '16px',
            lineHeight: 2,
            color: '#ffffff'
          }} data-id="element-33">
                <CheckIcon data-id="element-34" />
                <span style={{
              lineHeight: 1.5
            }} data-id="element-35">
                  {b}
                </span>
              </li>)}
          </ul>

          {/* 10. PRICE BLOCK */}
          <div className="mt-8 text-center rounded-lg" style={{
          backgroundColor: '#1a1a1a',
          padding: '32px'
        }} data-id="element-36">
            <span className="inline-block" style={{
            backgroundColor: '#f97316',
            color: '#ffffff',
            fontSize: '12px',
            fontWeight: 700,
            borderRadius: '9999px',
            padding: '5px 14px'
          }} data-id="element-37">
              AHORRAS 63%
            </span>
            <p style={{
            fontSize: '20px',
            color: '#6b7280',
            textDecoration: 'line-through',
            marginTop: '14px'
          }} data-id="element-38">
              Valor regular: $27
            </p>
            <p style={{
            fontSize: '56px',
            fontWeight: 800,
            color: '#f97316',
            lineHeight: 1.1
          }} data-id="element-39">
              $9.97
            </p>
            <p style={{
            fontSize: '14px',
            color: '#9ca3af',
            lineHeight: 1.6,
            marginTop: '8px'
          }} data-id="element-40">
              Tu compra de Kamasutra ya está guardada. Solo agregas esto con un
              clic.
            </p>
          </div>

          {/* 11. CTA — HOTMART Sales Funnel Widget */}
          <div className="mt-6" id="hotmart-sales-funnel" data-id="element-41" />

          {/* 12. REJECTION LINK */}
          <div className="text-center" style={{
          marginTop: '16px'
        }} data-id="element-42">
            <button type="button" className="underline cursor-pointer bg-transparent" style={{
            fontSize: '13px',
            color: '#6b7280'
          }} data-id="element-43">
              No gracias, prefiero salir sin esta oferta
            </button>
          </div>
        </div>
      </div>
    </main>;
}